import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClientService } from '@app/api/api-services/http-client.service';
import { PipPlanApiModel, PipPlanFormApiModel, PipSelectorsApiModel } from '@app/api/api-models/program/pip';

@Injectable()
export class PipPlansService {
  public apiUrl = 'pip-plans';

  constructor(private readonly http: HttpClientService) {}

  /** Active plan for the subject. The site always comes from the current user on the server. Responds 404 when there is none. */
  public getActivePlan(programRoleId: string): Observable<PipPlanApiModel> {
    return this.http
      .get<PipPlanApiModel>(`${this.apiUrl}/active`, { params: { programRoleId } })
      .pipe(map((x) => new PipPlanApiModel().deserialize(x)));
  }

  public getPlanForms(planId: number): Observable<PipPlanFormApiModel[]> {
    return this.http
      .get<PipPlanFormApiModel[]>(`${this.apiUrl}/${planId}/forms`)
      .pipe(map((array) => array.map((x) => new PipPlanFormApiModel().deserialize(x))));
  }

  public getSelectors(): Observable<PipSelectorsApiModel> {
    return this.http.get<PipSelectorsApiModel>(`${this.apiUrl}/selectors`);
  }
}
